module.exports = __webpack_public_path__ + "img/motor_no30.19261bcc.jpg";